"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightTheme = exports.darkTheme = exports.defaultTheme = void 0;
var breakpoint_1 = __importDefault(require("./breakpoint"));
var button_1 = __importDefault(require("./button"));
var colors_1 = __importDefault(require("./colors"));
var typography_1 = __importDefault(require("./typography"));
exports.defaultTheme = {
    breakpoints: {
        sm: '576px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
    },
    breakpoint: breakpoint_1.default,
    font: typography_1.default,
    button: button_1.default,
    layers: {
        base: 10,
        header: 15,
        menu: 25,
        overlay: 30,
        modal: 40,
        alwaysOnTop: 50,
    },
};
exports.darkTheme = __assign(__assign({}, exports.defaultTheme), { colors: colors_1.default.dark });
exports.lightTheme = __assign(__assign({}, exports.defaultTheme), { colors: colors_1.default.light });
